import { ButtonGroup, ButtonText } from "@visa/vds";
import Col from "@visa/vds/col";
import FormControl from "@visa/vds/form-control";
import Input from "@visa/vds/input";
import Row from "@visa/vds/row";
import Typography from "@visa/vds/typography";
import { ObjectMapHelper } from "_helpers/ObjectMapHelper";
import { updateCompanyUrl } from "_mappings/Organization";
import MCSReadonlyField from "components/MCSReadonlyField";
import { GlobalAlertContext } from "context/GlobalAlertContext";
import React from "react";
import { useContext } from "react";
import { trackPromise } from "react-promise-tracker";
import { userService } from "services/user.service";

const OrganizationInformation = (props) => {
  const alertContext = useContext(GlobalAlertContext);


  const handleClickUpdateCompanyUrl = () => {
    let mappedDto = ObjectMapHelper.MapDto(
      props.organizationData,
      updateCompanyUrl
    );

    trackPromise(
      userService
        .UpdateCompanyUrl(props.organizationData.id, mappedDto)
        .then((result) => {
          if (result.data.success) {
            alertContext.setSuccessMessage("Company URL Update Success");
          } else {
            alertContext.setErrorMessage("Company URL Update Failed");
          }
        })
        .catch((error) => {
          if (error.response.status == 400) {
            alertContext.setErrorMessage("This is not a URL. Please ensure that the Company URL entered starts with https or www.");
          } else {
            alertContext.setErrorMessage("Company URL Update Failed");
          }
        })
    );
  };

  return (
    <>
      <Row>
        <Col>
          <Typography tag="h2">Organization</Typography>
          <MCSReadonlyField
            label="Name"
            text={
              props.organizationData && props.organizationData.organizationName
            }
          />
          <MCSReadonlyField
            label="BID"
            text={props.organizationData && props.organizationData.bid}
          />
          <MCSReadonlyField
            label="Region"
            text={props.organizationData && props.organizationData.regionName}
          />
          <MCSReadonlyField
            label="Country"
            text={
              props.organizationData && props.organizationData.country
                ? props.organizationData.country.countryName
                : ""
            }
          />
          {!props.isCompanyAdmin && (
            <MCSReadonlyField
              label="Company URL"
              text={props.organizationData && props.organizationData.companyUrl}
            ></MCSReadonlyField>
          )}

          {props.isCompanyAdmin && (
            <>
              <MCSReadonlyField label="Company URL"></MCSReadonlyField>
              <div style={{ display: "flex" }}>
                <FormControl space="fifty">
                  <Input
                    name="companyUrl"
                    value={
                      props.organizationData &&
                        props.organizationData.companyUrl != null
                        ? props.organizationData.companyUrl
                        : ""
                    }
                    onChange={(e) => {
                      props.setOrganizationData({
                        ...props.organizationData,
                        companyUrl: e.target.value,
                      });
                    }}
                  />
                </FormControl>
                <div style={{ paddingTop: "4px", marginLeft: "4px" }}>
                  <ButtonGroup>
                    <ButtonText
                      name="companyUrlSave"
                      onClick={handleClickUpdateCompanyUrl}
                    >
                      Save
                    </ButtonText>
                  </ButtonGroup>
                </div>
              </div>
            </>
          )}
        </Col>
      </Row>
    </>
  );
};

export default OrganizationInformation;
